import { IScorecard } from './types';
import { Score } from '../Evaluation/EvaluationTemplate/Question/ScoreCard';

const splitScorecard = (item: string): IScorecard | null =>
  item.includes(':')
    ? {
        name: item.substring(0, item.lastIndexOf(':')),
        score: +item.substring(item.lastIndexOf(':') + 1, item.length),
      }
    : null;

export const convertToScorecards = (value: string): (IScorecard | null)[] =>
  value
    .split(/;|\n/)
    .map(splitScorecard)
    .filter((item) => !!item);

export const convertToString = (scorecards: IScorecard[]): string =>
  scorecards
    .map((scorecard) => `${scorecard.name}:${scorecard.score}`)
    .join('\n');

export const getScore = (scorecards: IScorecard[], name: string): Score => {
  const scorecard = findScorecard(scorecards, name);
  return scorecard && scorecard.score;
};

export const findScorecard = (
  scorecards: IScorecard[],
  name: string,
): IScorecard | undefined =>
  scorecards.find((scorecard) => scorecard.name === name);
